// import { Check, X } from 'react-feather'
import { toast } from 'react-toastify'

const toastConfig = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false
}
const success = (msg = 'Success' ) => {
  return toast.success(msg, toastConfig);
}

const error = (msg = 'Something was wrong!') => {
  return toast.error(msg, toastConfig);
}

export default {
  success,
  error
}